


//请求乐高基础数据
export const LIST_BASE_REQ = 'LIST_BASE_REQ'
//处理乐高基础数据
export const LIST_BASE_HANDLE = 'LIST_BASE_HANDLE'
//请求列表
export const LIST_REQ = 'LIST_REQ'

//处理列表
export const LIST_HANDLE = 'LIST_HANDLE'

//领取任务
export const TASK_REQ = 'TASK_REQ'

//领取任务后处理
export const TASK_HANDLE = 'TASK_HANDLE'


